import { __makeTemplateObject } from '../../_virtual/_tslib.js';
import { css } from 'styled-components';

var BaseSocialLoginButtonStyle = css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  padding-left: 0;\n  padding-right: 0;\n  width: 100%;\n  ", "\n  position: relative;\n\n  svg {\n    position: absolute;\n    left: 30px;\n  }\n"], ["\n  padding-left: 0;\n  padding-right: 0;\n  width: 100%;\n  ", "\n  position: relative;\n\n  svg {\n    position: absolute;\n    left: 30px;\n  }\n"])), function (_a) {
    var size = _a.size;
    return size === 'medium' && 'height: 5.6rem;';
});
var templateObject_1;

export { BaseSocialLoginButtonStyle };
